/**
 * GraphQL query strings for enrollment multi home-address
 * Extracted for use in E2E environments without Apollo Client dependencies
 */

export const getEnrollmentMultiHomeAddressDataQuery = `
  mutation getEnrollmentMultiHomeAddressData($submitEnrollmentInput: SubmitEnrollmentInput!) {
    submitEnrollment(submitEnrollmentInput: $submitEnrollmentInput) {
      ... on SubmitEnrollmentSuccess {
        __typename
        path
        enrollmentData {
          applicationId
          progress
          addressLine1
          addressLine2
          addressCity
          addressRegionCode
          addressPostalCode
        }
      }
      ... on SubmitEnrollmentError {
        __typename
        path
      }
    }
  }`

export const submitEnrollmentMultiHomeAddressDataQuery = `
  mutation submitEnrollmentMultiHomeAddressData($submitEnrollmentInput: SubmitEnrollmentInput!) {
    submitEnrollment(submitEnrollmentInput: $submitEnrollmentInput) {
      ... on SubmitEnrollmentSuccess {
        __typename
        path
      }
      ... on SubmitEnrollmentError {
        __typename
        path
      }
    }
  }`

